webpackJsonp([14238691822707],{

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(9);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdEmail = function MdEmail(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm33.4 13.4v-3.4l-13.4 8.4-13.4-8.4v3.4l13.4 8.2z m0-6.8q1.3 0 2.3 1.1t0.9 2.3v20q0 1.3-0.9 2.3t-2.3 1.1h-26.8q-1.3 0-2.3-1.1t-0.9-2.3v-20q0-1.3 0.9-2.3t2.3-1.1h26.8z' })
	        )
	    );
	};
	
	exports.default = MdEmail;
	module.exports = exports['default'];

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(9);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdPhoneAndroid = function MdPhoneAndroid(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.8 30v-23.4h-17.5v23.4h17.5z m-5.4 5v-1.6h-6.8v1.6h6.8z m3.2-33.4c2.8 0 5 2.3 5 5v26.8c0 2.7-2.2 5-5 5h-13.2c-2.8 0-5-2.3-5-5v-26.8c0-2.7 2.2-5 5-5h13.2z' })
	        )
	    );
	};
	
	exports.default = MdPhoneAndroid;
	module.exports = exports['default'];

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding-top: ', ';\n  padding-bottom: ', ';\n  padding-right: 0;\n  padding-left: ', ';\n  margin: 0;\n\n  color: ', ';\n  display: block;\n  font-size: ', ';\n  text-decoration: none;\n\n  &:hover {\n    background-color: ', '\n  }\n\n  .contact-icon {\n    padding-right: ', ';\n    font-size: ', ';\n  }\n\n  .country-icon {\n    padding-left: ', ';\n    font-size: ', ';\n  }\n'], ['\n  padding-top: ', ';\n  padding-bottom: ', ';\n  padding-right: 0;\n  padding-left: ', ';\n  margin: 0;\n\n  color: ', ';\n  display: block;\n  font-size: ', ';\n  text-decoration: none;\n\n  &:hover {\n    background-color: ', '\n  }\n\n  .contact-icon {\n    padding-right: ', ';\n    font-size: ', ';\n  }\n\n  .country-icon {\n    padding-left: ', ';\n    font-size: ', ';\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding-top: ', ';\n  padding-bottom: ', ';\n  padding-right: 0;\n  padding-left: 0;\n  margin: auto;\n\n  width: 100%;\n  max-width: 20rem;\n'], ['\n  padding-top: ', ';\n  padding-bottom: ', ';\n  padding-right: 0;\n  padding-left: 0;\n  margin: auto;\n\n  width: 100%;\n  max-width: 20rem;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _email = __webpack_require__(166);
	
	var _email2 = _interopRequireDefault(_email);
	
	var _phoneAndroid = __webpack_require__(167);
	
	var _phoneAndroid2 = _interopRequireDefault(_phoneAndroid);
	
	var _H = __webpack_require__(30);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Br = __webpack_require__(47);
	
	var _Br2 = _interopRequireDefault(_Br);
	
	var _Ca = __webpack_require__(31);
	
	var _Ca2 = _interopRequireDefault(_Ca);
	
	var _A = __webpack_require__(35);
	
	var _A2 = _interopRequireDefault(_A);
	
	var _reactIntl = __webpack_require__(7);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var getCountry = function getCountry(country) {
	  switch (country) {
	    case 'br':
	      return _react2.default.createElement(_Br2.default, { className: 'country-icon' });
	    case 'ca':
	      return _react2.default.createElement(_Ca2.default, { className: 'country-icon' });
	    default:
	      return null;
	  }
	};
	
	var getIcon = function getIcon(type) {
	  switch (type) {
	    case 'email':
	      return _react2.default.createElement(_email2.default, { className: 'contact-icon' });
	    case 'phone':
	      return _react2.default.createElement(_phoneAndroid2.default, { className: 'contact-icon' });
	    default:
	      return null;
	  }
	};
	
	var Link = (0, _styledComponents2.default)(_A2.default)(_templateObject, function (_ref) {
	  var theme = _ref.theme;
	  return theme.scale(0);
	}, function (_ref2) {
	  var theme = _ref2.theme;
	  return theme.scale(1);
	}, function (_ref3) {
	  var theme = _ref3.theme;
	  return theme.scale(0);
	}, function (_ref4) {
	  var theme = _ref4.theme;
	  return theme.colors.white;
	}, function (_ref5) {
	  var theme = _ref5.theme;
	  return theme.scale(1);
	}, function (_ref6) {
	  var theme = _ref6.theme;
	  return theme.colors.blackShades[0];
	}, function (_ref7) {
	  var theme = _ref7.theme;
	  return theme.scale(-2);
	}, function (_ref8) {
	  var theme = _ref8.theme;
	  return theme.scale(4);
	}, function (_ref9) {
	  var theme = _ref9.theme;
	  return theme.scale(-2);
	}, function (_ref10) {
	  var theme = _ref10.theme;
	  return theme.scale(3);
	});
	
	var ContactItem = function ContactItem(props) {
	  return _react2.default.createElement(
	    'li',
	    null,
	    _react2.default.createElement(
	      Link,
	      { href: props.link },
	      getIcon(props.type),
	      props.value,
	      getCountry(props.country)
	    )
	  );
	};
	
	ContactItem.propTypes = {
	  value: _propTypes2.default.string.isRequired,
	  type: _propTypes2.default.string.isRequired,
	  link: _propTypes2.default.string.isRequired,
	  country: _propTypes2.default.string
	};
	
	var Ul = _styledComponents2.default.ul(_templateObject2, function (_ref11) {
	  var theme = _ref11.theme;
	  return theme.scale(0);
	}, function (_ref12) {
	  var theme = _ref12.theme;
	  return theme.scale(7);
	});
	
	var Contact = function Contact(props) {
	  var contactList = props.data.site.siteMetadata.contact.map(function (contact) {
	    return _react2.default.createElement(ContactItem, contact);
	  });
	
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      _reactIntl.FormattedMessage,
	      { id: 'contact' },
	      function (txt) {
	        return _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(_reactHelmet2.default, {
	            title: txt,
	            meta: [{ name: 'description', content: txt }]
	          }),
	          _react2.default.createElement(
	            _H2.default,
	            null,
	            txt
	          )
	        );
	      }
	    ),
	    _react2.default.createElement(
	      Ul,
	      null,
	      contactList
	    )
	  );
	};
	
	Contact.propTypes = {
	  data: _propTypes2.default.shape({
	    site: _propTypes2.default.shape({
	      siteMetadata: _propTypes2.default.shape({
	        contact: _propTypes2.default.array
	      }).isRequired
	    }).isRequired
	  }).isRequired
	};
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Contact = __webpack_require__(117);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _graphql = __webpack_require__(13);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_Contact2.default, props);
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-index-pt-js-d9bb241f3d26be06bda1.js